import { render, staticRenderFns } from "./Family.vue?vue&type=template&id=112e932d&scoped=true"
import script from "./Family.vue?vue&type=script&lang=js"
export * from "./Family.vue?vue&type=script&lang=js"
import style0 from "./Family.vue?vue&type=style&index=0&id=112e932d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112e932d",
  null
  
)

export default component.exports